import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { ContentAssetRow } from "./types";

// GET /api/admin/content/assets/:id → { asset, viewCount }
//
// Phase 7 sub-bucket 13. Single detail key per asset; Phase 6 mutation hooks
// (useUpdateAsset / useToggleAssetArchive) already invalidate this key on
// success. `enabled: !!id` matches the tiers/forms convention so the hook
// is safe to call from a page that may not yet have a resolved id from the
// router params.
export type AssetDetailResponse = {
  asset: ContentAssetRow;
  viewCount: number;
};

export function useAssetDetail(id: string | undefined) {
  return useQuery<AssetDetailResponse, ApiClientError>({
    queryKey: id ? queryKeys.content.detail(id) : ["content", "detail", "__missing__"],
    queryFn: () => apiFetch<AssetDetailResponse>(`/admin/content/assets/${id}`),
    enabled: !!id,
  });
}
